"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCabinLuggage = function SvgCabinLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.685 4.352A9.68 9.68 0 0 1 12 4.267c.544 0 .99.04 1.315.085.146.02.291.115.38.293.121.244.252.525.37.813a81.852 81.852 0 0 0-4.13 0c.118-.288.249-.57.37-.813a.507.507 0 0 1 .38-.293ZM7.927 5.539c.195-.645.487-1.284.707-1.726a2.37 2.37 0 0 1 1.798-1.31c.402-.056.932-.103 1.568-.103s1.166.047 1.568.102c.808.11 1.457.627 1.798 1.31.22.443.512 1.082.707 1.727 1.705.097 2.94.247 3.801.389 1.33.219 2.224 1.302 2.35 2.58.13 1.325.276 3.399.276 5.165 0 2.626-.146 3.541-.277 4.866-.125 1.28-1.018 2.362-2.349 2.581-1.437.237-3.911.494-7.874.494-3.963 0-6.437-.257-7.874-.494-1.33-.22-2.224-1.302-2.35-2.58-.13-1.326-.276-2.24-.276-4.867 0-1.766.146-3.84.277-5.165.125-1.278 1.018-2.361 2.349-2.58.862-.142 2.096-.292 3.801-.389Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCabinLuggage);
var _default = exports["default"] = Memo;